import { withStyles } from "..";
import { Theme, Tooltip } from "@mui/material";

const DarkTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: theme.palette.grey[900],
  },
}))(Tooltip);

export default DarkTooltip;
